import type { ReactNode } from 'react';
import { NotificationBell } from './NotificationBell';
import { PeriodPicker } from './PeriodPicker';
import { UserMenu, type UserMenuProps } from './UserMenu';

export type PageHeaderProps = {
  greeting?: ReactNode;
  subtitle: ReactNode;
  period?: string;
  notifications?: number;
  user?: UserMenuProps;
};

/** Cabeçalho "Olá, Hallan" com período, sino e avatar (`.hello`). */
export function PageHeader({ greeting = 'Olá, Hallan', subtitle, period = 'Este mês', notifications = 3, user = { initials: 'H' } }: PageHeaderProps) {
  return (
    <div className="hello">
      <div>
        <b>{greeting}</b>
        <span>{subtitle}</span>
      </div>
      <div className="tools">
        <PeriodPicker value={period} />
        <NotificationBell count={notifications} />
        <UserMenu {...user} />
      </div>
    </div>
  );
}
